import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { useSnackbarContext } from 'context/SnackbarProvider/SnackbarProvider'

interface UploadPhotoParams {
  PK: string
  SK: string
  orgId: string
  formData: FormData
}

interface PreviousOrg {
  photoUrl?: string
  [key: string]: any
}

interface UploadContext {
  previousOrganization?: PreviousOrg
}

const uploadPhoto = async ({ formData }: UploadPhotoParams): Promise<any> => {
  const url = `${baseUrl}/aws/upload-organization-photo`
  console.log('FormData in uploadPhoto:', formData)

  const response = await axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return response.data
}

const useUploadPhoto = () => {
  const queryClient = useQueryClient()
  const { showSnackbar } = useSnackbarContext()

  return useMutation<any, Error, UploadPhotoParams, UploadContext>({
    mutationFn: uploadPhoto,

    onMutate: async ({ PK, SK: _SK, formData }) => {
      await queryClient.cancelQueries({ queryKey: ['organizations', PK] })

      const previousOrganization = queryClient.getQueryData<PreviousOrg>(['organizations', PK])

      queryClient.setQueryData(['organizations', PK], (old: any) => ({
        ...old,
        photoUrl: URL.createObjectURL(formData.get('file') as Blob),
      }))

      return { previousOrganization }
    },

    onError: (err, { PK }, context) => {
      if (context?.previousOrganization) {
        queryClient.setQueryData(['organizations', PK], context.previousOrganization)
      }
      console.error('Mutation Error:', err)
      showSnackbar(err?.message || 'Failed to upload photo.', 'error')
    },

    onSuccess: (_data, { PK: _PK }) => {
      queryClient.invalidateQueries({ queryKey: ['organizations'] })

      showSnackbar('Photo uploaded successfully', 'success')
    },
  })
}

export default useUploadPhoto
